// OverlayMenu.jsx - Finalized without useOverlay()

import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import logo from "../../../assets/icons/NewLogo.png";
import profilelogo from "../../../assets/icons/logo.svg";
import OverlayHeader from "../../../shared/components/OverlayHeader";
import SlideOver from "../components/SlideOver";
import { ReactComponent as InsightsIcon } from "../../../assets/icons/insights.svg";
import { ReactComponent as JournalIcon } from "../../../assets/icons/journal.svg";


import newSessionIcon from "../../../assets/icons/newsession.svg";
import deleteIcon from "../../../assets/icons/delete.svg";
import archiveIcon from "../../../assets/icons/archive.svg";
import renameIcon from "../../../assets/icons/rename.svg";
import feedbackIcon from "../../../assets/icons/feedback.svg";
import logoutIcon from "../../../assets/icons/logout.svg";

import { AuthServices } from "../../auth/services/AuthServices";
import { OverlayService } from "../service/OverlayService";
import "../../../styles/Overlay.css";
import { useWebSocketChat } from "../../../socket/useSocket";
import { FiEdit, FiSmile } from "react-icons/fi";
import { formatToLocalDateFancy, formatToLocalDateTimeFancy , formatToLocalTimeFancy} from "../../../shared/utils/dateFormatter";

const JournalPanel = lazy(() => import("../components/JournalPanel"));
const MoodPanel = lazy(() => import("../components/Moodpanel"));
const InsightsPanel = lazy(() => import("../components/InsightsPanel"));
const ProfilePanel = lazy(() => import("../../profile/pages/ProfilePage"));
const HelpPanel = lazy(() => import("../../profile/pages/HelpPage"));
const ArchivePanel = lazy(() => import("../../profile/pages/ArchivedSessions"));



function OverlayMenu({ isActive, setIsActive }) {
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [rating, setRating] = useState(5);
  const [feedbackText, setFeedbackText] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [renameInput, setRenameInput] = useState("");
  const [conversation_id, setConversation_id] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [activeMenuTitle, setActiveMenuTitle] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [firstMatchIndex, setFirstMatchIndex] = useState(null);
  const [overlayRefresh, setOverlayRefresh] = useState(null);
  const [isLogout, setIsLogout] = useState(false);
  const [countdown, setCountdown] = useState(3);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [panel, setPanel] = useState(null);
  const openPanel = (key) => setPanel(String(key).toLowerCase());
  const closePanel = () => setPanel(null);

  const { disconnectWebSocket, updatePatientId } = useWebSocketChat({
    setCompleteAudio: "",
    onStreamingStart: "",
    onStreamingText: "",
    onStreamingAudio: "",
    onStreamingComplete: "",
    onStreamingError: "",
    onTranscription: "",
    onConversationHistory: "",
  });

  const popupRef = useRef(null);
  const matchRef = useRef(null);
  let conv_date = null;
  const lastCountedIdRef = useRef(null);
  const [user, setUser] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const [isExiting, setIsExiting] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => {
    setIsActive(false);/*
    setIsExiting(true);
    setTimeout(() => {
      setIsActive(false);
      setIsExiting(false);
    }, 600);*/
  };

  /*
  const handleLogout = async () => {
    try {
      const response = await AuthServices.logout();
      if (response.status !== 200) {
        // return alert('Logout failed, please try again.');
      }
      localStorage.clear();
      setUser(null);
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };
*/
  

const handleLogout = async () => {
  setIsLogout(true);
  setCountdown(3); // reset timer

  try {
    const response = await AuthServices.logout();
    if (response.status !== 200) {
      console.error('Logout failed, please try again.');
    }
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          localStorage.clear();
          navigate("/login");
        }
        return prev - 1;
      });
    }, 1000);
  }
};

  const handleNewSessionClick = async () => {
    setIsActive(false);
    try {
      const response = await OverlayService.createNewSession();

       localStorage.setItem("conversation_id", response.conversation_id);
       localStorage.setItem("expertReplyCount", "0");
       //setConversations(prev => [response, ...prev]);
       setOverlayRefresh("newsession");
       //setTimeout(() => {
        
       navigate("/home", { replace: true ,
        state: { 
        ischatVisible: false,    // pass any data you want
        ischatMode: false,
        session: null
        }
      });
              
     /* setTimeout(() => {
        window.location.href = "/home";
      }, 100); 
*/
      disconnectWebSocket();

    //},2000);

    } catch (error) {
      console.log("Failed to start a new session. Please try again.");
      return;
    }
  };

  const submitfeedback = async (rating, feedbackText) => {
    try {
      console.log("Coming to overlayMenu")
      const response = await OverlayService.Feedback(rating, feedbackText);
    } catch (error) {
      console.log("Failed to submit the feeback. Please try again.");
      return;
    }
  };

  const updateconversation = async (conversation_id, actiontype, title) => {
    try {
      const response = await OverlayService.updateConversation(
        conversation_id,
        actiontype,
        title
      );
      setSuccessMessage(
                    actionType === "rename"
                      ? "Successfully Renamed!"
                      : "Successfully Archived!"
                  );
                  
      setShowSuccessPopup(true);
      setTimeout(() => setShowSuccessPopup(false), 2000);

      setOverlayRefresh(response);
    } catch (error) {
      console.error("unable to upadte the conversation", error);
    }
  };

  const deleteconversation = async (conversation_id) => {
    try {
      console.log("conversation id passed to service layer", conversation_id);
      const response = await OverlayService.deleteOneConversation(
        conversation_id
      );
      
      setSuccessMessage("Successfully Deleted!");
      setShowSuccessPopup(true);
      setTimeout(() => setShowSuccessPopup(false), 2000);

      setOverlayRefresh(response);
      console.log("response getting from teh api", response);
    } catch (error) {
      console.error("error while deleting the api", error);
    }
  };

  const handleViewProfile = () => {
    setIsActive(false);
    navigate("/profile");
  };

  const highlightMatch = (text, query) => {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, "ig");
    return text
      .split(regex)
      .map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <mark key={i}>{part}</mark>
        ) : (
          <span key={i}>{part}</span>
        )
      );
  };
  
  /*const filteredConversations = conversations.slice().sort((a, b) => {
    const aMatch = a.title.toLowerCase().includes(searchTerm.toLowerCase())
      ? 0
      : 1;
    const bMatch = b.title.toLowerCase().includes(searchTerm.toLowerCase())
      ? 0
      : 1;
    return aMatch - bMatch;
  });
*/
  const filteredConversations = searchTerm
  ? conversations.filter(conversation =>
      conversation.title.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : conversations;

  // const handleSaveJournal = async (journalEntry) => {
  //   console.log(journalEntry);
  //   const { id, body, title } = journalEntry;
  //   const response = await OverlayService.saveJournalEntry(id, body, title);
  //   // if (response.status !== 200) {
  //   //   console.log("there was an error saving your jounal entry");
  //   //   return;
  //   // }
  //   console.log(response);
  // };

  const handleSaveJournal = async (journalEntry) => {
    try {
      console.log("Saving journal entry:", journalEntry);
      const { id, body, title } = journalEntry;
      if (typeof OverlayService.createJournalEntry !== "function") {
        throw new Error("OverlayService.createJournalEntry is not defined");
      }
      const response = await OverlayService.createJournalEntry(id, body, title);
      console.log("Journal saved successfully:", response);
    } catch (error) {
      console.error("Error saving journal entry:", error.message || error);
    }
  };

  useEffect(() => setIsActive(false), [location.pathname]);

  useEffect(() => {
    setOverlayRefresh("newsession");
    if (isActive) {
      setShouldRender(true);
      setAnimateIn(true);
    } else {
      setIsExiting(true);
      setTimeout(() => {
        setIsExiting(false);
        setShouldRender(false);
      }, 500);
    }
  }, [isActive]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setIsActive(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [setIsActive]);

  useEffect(() => {
    if (showFeedbackModal) {
      setRating(5);
    }
  }, [showFeedbackModal]);

  useEffect(() => {
    document.body.classList.toggle("overlay-active", isActive);
    return () => document.body.classList.remove("overlay-active");
  }, [isActive]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setActiveMenuTitle(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchConversations = async () => {
      try {
        const response = await OverlayService.fetchAllConversations();
        console.log("converstion respons here is", response);
        const data = response?.conversations || [];
        setConversations(data);
      } catch (error) {
        console.error("Error loading conversations:", error);
      }
    };
    
  useEffect(() => {
    
    fetchConversations();
  }, [overlayRefresh]);

  useEffect(() => {
    fetchConversations();
    setOverlayRefresh("newsession");
    if (isActive) {
      setShouldRender(true);
      setAnimateIn(true);
    } else {
      setIsExiting(true);
      setTimeout(() => {
        setIsExiting(false);
        setShouldRender(false);
      }, 500);
    }
  }, [isActive]);

  useEffect(() => {
    if (!searchTerm) {
      setFirstMatchIndex(null);
      return;
    }
    const index = conversations.findIndex((conv) =>
      conv.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFirstMatchIndex(index);
  }, [searchTerm, conversations]);

  useEffect(() => {
    if (matchRef.current) {
      matchRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [firstMatchIndex]);

  const fetchUserData = async () => {
    try {
      const response = await AuthServices.fetchUserData();
      const fetchedUser = response?.data?.data?.user;

      if (fetchedUser) {
        setUser(fetchedUser);
        localStorage.setItem("user", JSON.stringify(fetchedUser));

        if (fetchedUser.patient_id) {
          updatePatientId(fetchedUser.patient_id);
        }
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  if (!shouldRender) return null;



  return (
    <div
      className={`overlay-backdrop ${isExiting ? "fade-out" : "fade-in"}`}
      onClick={handleClose}
    >
      <div
        className={`overlay-container ${isExiting ? "slide-out" : animateIn ? "slide-in" : ""
          }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <OverlayHeader onBack={handleClose} />

        {/* Body */}
        <div className="overlay-body-wrapper" ></div>
        <div className="overlay-body">
          <div className="section">
            <h4 className="section-title">Quick Actions</h4>
            <div className="search-bar">
              <FiSearch size={16} />
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="action-item" onClick={handleNewSessionClick}>
              <img
                src={newSessionIcon}
                alt="New Session"
                className="menu-icon"
              />
              <span>New Session</span>
            </div>
            <div className="action-item" onClick={() => openPanel("journal")} >

              {/* <JournalIcon width={20} height={20} /> */}
              <FiEdit size={20} />
              <span>Journal</span>
            </div>
            <div className="action-item" onClick={() => openPanel("mood")} >
              <FiSmile size={22} />

              <span>Mood Tracking</span>
            </div>
            <div className="action-item" onClick={() => openPanel("insights")} >
              <InsightsIcon width={22} height={22} />

              <span>Insights</span>
            </div>
            <SlideOver title={panel === "mood" ? "Mood" : panel === "journal" ? "Journal" 
              : panel === "insights" ? "Insights" :  panel === "profile" ? "Profile" 
              : panel === "help" ? "Help" :  panel === "archive" ? "Archive" :""} isOpen={!!panel} onClose={closePanel}
              width={panel === "profile" ? "100vw" : undefined} 
              >
              {panel && (
                <Suspense fallback={<div>Loading…</div>}>
                  {panel === "journal" && <JournalPanel onClose={closePanel} onSave={handleSaveJournal} />}
                  {panel === "mood" && <MoodPanel onClose={closePanel} />}
                  {panel === "insights" && <InsightsPanel onClose={closePanel} />}
                  {panel === "profile" && <ProfilePanel onClose={closePanel}  />}
                  {panel === "help" && <HelpPanel onClose={closePanel} />}
                  {panel === "archive" && <ArchivePanel onClose={closePanel} />}
                </Suspense>
              )}
            </SlideOver>

            <div
              className="action-item"
              onClick={() => setShowFeedbackModal(true)}
            >
              <img src={feedbackIcon} alt="Feedback" className="menu-icon" />
              <span>Feedback</span>
            </div>
          </div>

              
            
          <div className="section">
            <h4 className="section-title">Conversation</h4>
            <ul className="conversation-list">
              {filteredConversations.length===0 ? (
              <li>No Conversation Found</li>
            ):(

              filteredConversations.map((conv, index) => {
                const idx = conversations.indexOf(conv.conversation_id);
                const convDate = formatToLocalDateFancy(conv.createdat);

                const showDateHeader = convDate !== conv_date;
                if (showDateHeader) {
                  conv_date = convDate;
              }

                return (
                  //  window.location.href = `/home?session=${encodeURIComponent(
                  //           conv.conversation_id
                  //         )
                  <React.Fragment key={index}>
                    {showDateHeader && (
                      <div className="date-header"><b>On {convDate}</b></div>
                  )}

                  <li className="conversation-item"
                  //</React.Fragment>key={index}>
                  >

                    

                    <div
                      className="chat-title clickable"
                      onClick={() => {
                        setIsActive(false);

                        localStorage.setItem("expertReplyCount", "0");
                        lastCountedIdRef.current = null;
                        localStorage.removeItem("lastCountedMsgId");
                        localStorage.setItem("conversation_id", conv.conversation_id);

                        navigate("/home", { replace: true ,
                                            state: { 
                                            ischatVisible: true,    // pass any data you want
                                            session: conv.conversation_id
                                            }
                                });

                        /*window.location.href = `/home?session=${encodeURIComponent(
                          conv.conversation_id
                        )}`;
                        */

                        window.dispatchEvent(new PopStateEvent("popstate"));
                      }}
                    >
                      {highlightMatch('\u00A0\u00A0\u00A0'+ formatToLocalTimeFancy(conv.createdat) +' : '+ conv.title, searchTerm)}
                    </div>

                    <div style={{ position: "relative" }}>
                      <button
                        className="dots-button"
                        onClick={() =>
                          setActiveMenuIndex(
                            setActiveMenuTitle(
                              activeMenuTitle === conv.conversation_id
                                ? null
                                : conv.conversation_id
                            )
                          )
                        }
                      >
                        <span>⋮</span>
                      </button>
                      {activeMenuTitle === conv.conversation_id && (
                        <div className="popup-menu-overlay" ref={popupRef}>
                          <div
                            className="popup-item"
                            onClick={() => {
                              setActionType("rename");
                              setRenameInput(conv.title);
                              setConversation_id(conv.conversation_id);
                              setSelectedIndex(idx);
                              setShowConfirmModal(true);
                              setActiveMenuTitle(null);
                            }}
                          >
                            <img
                              src={renameIcon}
                              alt="Rename"
                              className="popup-icon"
                            />{" "}
                            Rename
                          </div>
                          <div
                            className="popup-item"
                            onClick={() => {
                              setActionType("archive");
                              setSelectedIndex(idx);
                              setConversation_id(conv.conversation_id);
                              // handleArchive(conv.title);
                              setShowConfirmModal(true);
                              setActiveMenuIndex(null);
                              setActiveMenuTitle(null);
                            }}
                          >
                            <img
                              src={archiveIcon}
                              alt="Archive"
                              className="popup-icon"
                            />{" "}
                            Archive
                          </div>
                          <hr className="popup-divider" />
                          <div
                            className="popup-item delete"
                            onClick={() => {
                              setActionType("delete");
                              setSelectedIndex(idx);
                              setConversation_id(conv.conversation_id);
                              setShowConfirmModal(true);
                              setActiveMenuIndex(null);
                              setActiveMenuTitle(null);
                            }}
                          >
                            <img
                              src={deleteIcon}
                              alt="Delete"
                              className="popup-icon"
                            />{" "}
                            Delete
                          </div>
                        </div>
                      )}
                    </div>
                  </li>
                  </React.Fragment>
                );
              })
            )}
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div className="overlay-footer">
          <div className="footer-info">
            <div className="name-section">
              <img
                src={
                  user && user?.profile_picture
                    ? user?.profile_picture
                    : profilelogo
                }
                alt="Profile"
                className="profile-pic"
              />
              <div className="name-and-link">
                <p className="name">
                  {user?.first_name
                    ? `${user.first_name} ${user.last_name}`
                    : null}
                </p>
                <p className="profile-link" onClick={() => openPanel("profile")}>
                {/*<p className="profile-link" onClick={() => openPanel("profile")} /*onClick={handleViewProfile}>*/}
                  View Profile
                </p>
              </div>
            </div>
          </div>
          <button className="profile-icon" onClick={handleLogout}>
            <img src={logoutIcon} alt="Logout" className="logout-icon" />
          </button>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowConfirmModal(false)}
        >
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">Confirm {actionType}</h3>
            {actionType === "rename" ? (
              <>
                <p className="modal-text">Enter new name for the session:</p>
                <input
                  className="modal-input"
                  type="text"
                  value={renameInput}
                  onChange={(e) => setRenameInput(e.target.value)}
                />
              </>
            ) : (
              <p className="modal-text">
                Are you sure you want to {actionType} this session?
              </p>
            )}
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
              <button
                className="confirm-btn"
                onClick={() => {
                  if (selectedIndex !== null) {
                    if (actionType === "rename") {
                      updateconversation(
                        conversation_id,
                        "rename",
                        renameInput
                      );
                      setOverlayRefresh("rename");
                      const updated = [...conversations];
                      // updated[selectedIndex] = renameInput;
                      updated[selectedIndex] = {
                        ...updated[selectedIndex],
                        title: renameInput,
                      };
                      setConversations(updated);
                    } else if (actionType === "delete") {
                      deleteconversation(conversation_id);
                      setConversations((prev) =>
                        prev.filter((_, i) => i !== selectedIndex)
                      );
                    } else if (actionType === "archive") {
                      updateconversation(conversation_id, "archive", null);
                      setConversations((prev) =>
                        prev.filter((_, i) => i !== selectedIndex)
                      );
                    }
                  }
                  setShowConfirmModal(false);
                  setSelectedIndex(null);
                  setRenameInput("");
                }}
              >
                Yes, {actionType}
              </button>
            </div>
          </div>
        </div>
      )}



{isLogout && (
  <div className="logout-overlay">
    <div className="logout-modal">
      <img
              src={logo}
              alt="Prashasync Logo"
              className="modal-logo-google"
            />
      <h3>Thank you for today's session</h3>
      <p>
        Have a great {new Date().getHours() < 17 ? "day" : "evening"} — see you soon!
      </p>
      <p style={{ marginTop: "15px", fontWeight: "bold" }}>
        Logging out in {countdown}...
      </p>
    </div>
  </div>
)}


{showSuccessPopup && (
        <div className="success-toast">
          <span>{successMessage}</span>
        </div>
      )}



      {/* Feedback Modal */}
      {showFeedbackModal && (
        <div
          className="bottomSlide-modal-overlay"
          onClick={() => setShowFeedbackModal(false)}
        >
          <div className="bottomSlide-modal" onClick={(e) => e.stopPropagation()}>
            {submitted ? (
              <>
                <button
                  className="bottomSlide-close-btn"
                  onClick={() => setShowFeedbackModal(false)}
                >
                  ✖
                </button>
                <div className="thank-you-message">
                  <h3 style={{ fontSize: "18px", color: "#000" }}>
                    Thank you for your feedback!
                  </h3>
                </div>
              </>
            ) : (
              <>
                <button
                  className="bottomSlide-close-btn"
                  onClick={() => setShowFeedbackModal(false)}
                >
                  ✖
                </button>
                <div className="emoji">
                  {["🤔", "😞", "😐", "😐", "😄", "😍"][rating] || "🤔"}
                </div>
                <div className="stars-row">
                  {[1, 2, 3, 4, 5].map((val) => (
                    <span
                      key={val}
                      className={`star ${val <= rating ? "filled" : ""}`}
                      onClick={() => setRating(val)}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <h3>Tell Us</h3>
                <p>
                  {rating >= 4
                    ? "We’re thrilled to hear that! "
                    : rating > 0
                      ? "We’re sorry the experience didn’t meet your expectations."
                      : "How was your experience?"}
                </p>
                <p className="prompt">
                  {rating >= 4
                    ? "What did you enjoy the most, and is there anything we can do to make your experience even better?"
                    : rating > 0
                      ? "Could you share what specifically didn’t work for you, and how we can do better next time?"
                      : "Tap a star and share your thoughts!"}
                </p>
                <textarea
                  value={feedbackText}
                  onChange={(e) => setFeedbackText(e.target.value)}
                  placeholder="Type here..."
                  maxLength={500}
                />
                <div className="char-count">{feedbackText.length}/500</div>
                <button
                  className="submit-btn"
                  disabled={rating === 0}
                  onClick={() => {
                    setSubmitted(true);
                    
                      submitfeedback(rating, feedbackText);
                      setTimeout(() => {
                      setSubmitted(false);
                      setShowFeedbackModal(false);
                      setRating(5);
                      setFeedbackText("");
                      //navigate("/home");
                      handleClose();
                    }, 4000);
                  }}
                >
                  Submit
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default OverlayMenu;




